import { StoryblokEdge } from '../../interfaces/StoryblokEdge.interface';

export const getUrl = (): string | undefined => {
  if (typeof window !== 'undefined') return window.location.pathname;
};
